import { Box, Card, CardContent, Typography } from "@mui/material";
import { CHART_COLORS, chartSx } from "../../../../components/charts/chartTheme";

import { LineChart } from "@mui/x-charts/LineChart";
import { AttendanceYearlyPoint } from "../types";
import { PlaceholderBadge } from "./PlaceholderBadge";
import { EmptyState } from "./EmptyState";
import { cardTitleSx, dashboardCardSx } from "../responsiveText";

type AttendanceTrendCardProps = {
  data: AttendanceYearlyPoint[];
};

export const AttendanceTrendCard = ({ data }: AttendanceTrendCardProps) => {
  return (
    <Card elevation={0} sx={dashboardCardSx}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="subtitle1" fontWeight={600} sx={cardTitleSx}>
              Attendance Trend
            </Typography>
            <Typography variant="caption" color="text.secondary">
              This academic year
            </Typography>
          </Box>
          <PlaceholderBadge />
        </Box>

        {data.length === 0 ? (
          <EmptyState message="No attendance trend yet" height={220} />
        ) : (
          <Box sx={{ mt: 1 }}>
            <LineChart
              xAxis={[{ scaleType: "point", data: data.map((d) => d.month), disableTicks: true }]}
              yAxis={[{ min: 0, max: 100, width: 40, disableLine: true, disableTicks: true, valueFormatter: (v: number) => `${v}%` }]}
              series={[
                {
                  data: data.map((d) => d.presentPercent),
                  label: "Present %",
                  color: CHART_COLORS.series1,
                  area: true,
                  curve: "monotoneX",
                  showMark: false,
                },
              ]}
              height={220}
              hideLegend
              grid={{ horizontal: true }}
              sx={chartSx}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
